import { PspContext } from "@/config/contexts";
import { translate } from "@/config/translator";
import { useContext } from "react";
import { Link } from "react-router-dom";

export function CookiesAndPrivacyLinks() {
  const { lang } = useContext(PspContext);
  return (
    <div className="flex flex-row justify-center">
      <div className="flex flex-row gap-2 items-center underline text-primary">
        <Link to="/logged-in/privacy-policy">{translate("privacy", lang)}</Link>
        |<Link to="/logged-in/cookie-policy">{translate("cookies", lang)}</Link>
      </div>
    </div>
  );
}
